import React from "react";
import { StyledButton, ButtonSpinner } from "./Button.styles";
import { ButtonProps } from "./Button.types";

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  type = "button",
  variant = "primary",
  size = "md",
  fullWidth = false,
  disabled = false,
  loading = false,
  className,
}) => (
  <StyledButton
    type={type}
    onClick={onClick}
    disabled={disabled || loading}
    aria-busy={loading || undefined}
    $variant={variant}
    $size={size}
    $fullWidth={fullWidth}
    className={className}
  >
    {loading ? <ButtonSpinner aria-hidden="true" /> : null}
    {children}
  </StyledButton>
);

export default Button;
